<template>
  <div class="slide narrow" id="tell-your-mp" v-show="isVisibleSlide('tell-your-mp')">
    <div class="slide_inner">
      <div class="left"></div>
      <div class="container">
        <h1>TELL YOUR MP WHY YOU SUPPORT ASSISTED DYING</h1>
        <p>We're collecting messages from people in your constituency to deliver to your MP and help persuade them to support the campaign.</p>
        <p>In as many words as you like, tell your MP why you support assisted dying, and why they should too.</p>
        <p>If you or someone you know has been affected by a terminal illness, do write about it if you feel comfortable doing so - stories like yours can be extremely powerful.</p>
        <form class="action-form" @submit.prevent="submitForm">
          <div class="input-group">
            <label for="message">Your message</label>
            <textarea
              name="message"
              id="message"
              rows="5"
              v-model="form.message"
              v-validate="'required|min:1'"
            ></textarea>
            <p
              v-if="errors.has('message')"
              class="validation-error"
              role="alert"
            >Your message is required</p>
          </div>
          <!-- <p>Now, please enter a few more details below (just so your MP knows you're one of their constituents).</p> -->
          <input
            type="text"
            name="firstname"
            id="firstname"
            v-model="form.firstname"
            disabled
            hidden
          >
          <input type="email" name="email" id="email" v-model="form.email" disabled hidden>

          <div class="input-group" v-show="!$store.state.user.postcode">
            <label for="postcode">Postcode</label>
            <input
              type="text"
              name="postcode"
              id="postcode"
              v-model="form.postcode"
              v-validate="'required|min:1'"
            >
            <p
              v-if="errors.has('postcode')"
              class="validation-error"
              role="alert"
            >Postcode is required</p>
          </div>
          <div class="input-group">
            <button type="submit" class="btn-submit">SUBMIT MY MESSAGE</button>
          </div>
        </form>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import qs from "qs";
import { mapState } from "vuex";

export default {
  name: "TellYourMP",
  props: ["gotoSlide", "isVisibleSlide", "analytics"],
  data() {
    return {
      form: {
        firstname: null,
        lastname: null,
        address: null,
        email: null,
        postcode: null,
        message: null
      }
    };
  },
  computed: mapState(["user"]),
  watch: {
    user(newValue) {
      this.form.firstname = newValue.firstname;
      this.form.email = newValue.email;
      this.form.postcode = newValue.postcode;
    }
  },
  methods: {
    dumpCookies(cname, cvalue, exdays) {
      var d = new Date();
      d.setTime(d.getTime() - 100 * 24 * 60 * 60 * 1000);
      var expires = "expires=" + d.toUTCString();
      document.cookie = "JSESSIONID= ;" + expires + ";path=/page";
      document.cookie =
        "en_sessionId= ;" +
        expires +
        ";path=/page;domain=.dignityindying.org.uk;";
    },
    submitForm() {
      this.$validator.validateAll().then(valid => {
        if (valid) {
          this.dumpCookies();
          const data = {
            hidden: "",
            "supporter.questions.403545": this.form.message,
            "supporter.firstName": this.$store.state.user.firstname,
            "supporter.lastName": "lastname",
            "supporter.emailAddress": this.$store.state.user.email,
            "supporter.postcode": this.$store.state.user.postcode,
            "supporter.address1": "address1",
            "supporter.questions.384955": this.$store.state.user.optin, //optin
            "supporter.questions.402492": this.$store.state.mp.priority, //priority
            "supporter.questions.408376": this.$store.state.mp.constituency, //const
            "supporter.questions.408377": this.$store.state.mp.name //name
          };

          const options = {
            method: "POST",
            headers: { "content-type": "application/x-www-form-urlencoded" },
            data: qs.stringify(data),
            withCredentials: false,
            url: "https://action.dignityindying.org.uk/page/40610/petition/2"
          };

          axios(options)
            .then(response => {
              console.log(response);
              this.$store.commit("updateUser", {
                ...this.form,
                optin: this.$store.state.user.optin
              });
              this.analytics("tell_your_mp", "submitted");
              // eslint-disable-next-line
              fbq("trackCustom", "StoryComplete");
              this.gotoSlide("meet-ask");
            })
            .catch(error => {
              console.log(error);

              // just for testing offline
              // this.$store.commit("updateUser", {
              //   ...this.form,
              //   optin: this.$store.state.user.optin
              // });
              // this.analytics("tell_your_mp", "submitted");
              // this.gotoSlide("meet-ask");
            });
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.slide {
  background-image: url("https://aaf1a18515da0e792f78-c27fdabe952dfc357fe25ebf5c8897ee.ssl.cf5.rackcdn.com/2162/did-mp_0.jpg?v=1553533841000") !important;
}
</style>